import React from "react";
import {
  Create,
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  NumberInput,
  useRedirect,
  useRefresh,
  CreateProps,
} from "react-admin";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomCreateToolbar from "components/CustomCreateToolbar";

interface ICustomRedirect {
  data: IArea;
}

const AreasCreate = (props: CreateProps) => {
  const param = GetParam();
  const redirect = useRedirect();
  const refresh = useRefresh();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Areas", link: `/schools/${param.get("schoolId")}/show/3` },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = ({ data }: ICustomRedirect) => {
    redirect(`/schools/${data.schoolId}/show/3`);
    refresh();
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <Typography variant="h4">New Area</Typography>
      <Create onSuccess={CustomRedirect} {...props}>
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">School</Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={4}>
              <NumberInput source="maxDistanceInMeters" />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </Create>
    </>
  );
};

export default AreasCreate;
